<template>
  <v-overlay absolute opacity="0.25">
    <div v-if="show" class="banner">
      Hang on a moment while we’re loading…NextEra Energy is helping create
      sustainable energy that’s efficient, clean and affordable.
    </div>

    <v-progress-circular v-else indeterminate size="64"></v-progress-circular>
  </v-overlay>
</template>

<script>
const vueName = 'LoadingView';
export default {
  name: vueName,
  props: ['show']
};
</script>

<style lang="scss" scoped>
.banner {
  color: $ne-textcolor;
}
</style>
